import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "fill-circle-exclamation",
  "use": "fill-circle-exclamation-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"fill-circle-exclamation\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8 16A8 8 0 108 0a8 8 0 000 16zm0-3a1 1 0 100-2 1 1 0 000 2zM7 4a1 1 0 012 0v4a1 1 0 01-2 0V4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol